import { ProblemDetails, ResponseResult } from "@/core/models/response-result";
import { keycloakInstance } from "@/modules/auth/services/authService";
import axios from "axios";

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  paramsSerializer: {
    indexes: null, // this removes the brackets/indexes for arrays
  },
});

instance.interceptors.request.use(
  (config) => {
    const keycloak = keycloakInstance();

    // Only add the token if it's available
    if (keycloak && keycloak.token) {
      config.headers["Authorization"] = `Bearer ${keycloak.token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const keycloak = keycloakInstance();

    // Check if the error is due to an expired token
    if (error.response.status === 401 && keycloak) {
      try {
        // Attempt to refresh the token
        await keycloak.updateToken(30); // Refresh if the token is expiring within 30 seconds

        // Retry the request with the new token
        originalRequest.headers["Authorization"] = `Bearer ${keycloak.token}`;
        return instance(originalRequest);
      } catch (refreshError) {
        console.error("Token refresh failed", refreshError);
        // Redirect to login or handle the error appropriately
        keycloak.login();
      }
    }

    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  (response) => {
    response.data = new ResponseResult({
      isSuccess: true,
      data: response.data,
    });
    return response;
  },
  (error) => {
    if (axios.isAxiosError(error) && error.response) {
      return Promise.resolve({
        ...error.response,
        data: ResponseResult.fromProblemDetails(
          error.response.data as ProblemDetails,
          error.response.status,
        ),
      });
    }
    return Promise.resolve({
      data: ResponseResult.defaultError(error),
    });
  },
);

export default instance;
